"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var addSubDevResp_1 = __importDefault(require("./addSubDevResp"));
var appSend_1 = __importDefault(require("./appSend"));
var devLoginResp_1 = __importDefault(require("./devLoginResp"));
var devSync_1 = __importDefault(require("./devSync"));
var gatewayLoginResp_1 = __importDefault(require("./gatewayLoginResp"));
var getTimerListResp_1 = __importDefault(require("./getTimerListResp"));
var heartbeatResp_1 = __importDefault(require("./heartbeatResp"));
var reportDevInfoResp_1 = __importDefault(require("./reportDevInfoResp"));
var reportSubDevInfoResp_1 = __importDefault(require("./reportSubDevInfoResp"));
var requestVerifyResp_1 = __importDefault(require("./requestVerifyResp"));
exports.default = (function (virtual) { return ({
    addSubDevResp: addSubDevResp_1.default(virtual),
    appSend: appSend_1.default(virtual),
    devLoginResp: devLoginResp_1.default(virtual),
    devSync: devSync_1.default(virtual),
    gatewayLoginResp: gatewayLoginResp_1.default(virtual),
    getTimerListResp: getTimerListResp_1.default(virtual),
    heartbeatResp: heartbeatResp_1.default(virtual),
    reportDevInfoResp: reportDevInfoResp_1.default(virtual),
    reportSubDevInfoResp: reportSubDevInfoResp_1.default(virtual),
    requestVerifyResp: requestVerifyResp_1.default(virtual)
}); });



// WEBPACK FOOTER //
// ./src/actions/receive/actions/index.ts